<mat-slide-toggle (change)="onChange($event)">Flag Collectible</mat-slide-toggle>
